<template>
  <vh-dialog :visible="visible" width="580px" :before-close="handleClose">
    <h3 slot="title" class="dialog-title">
      {{ $t('lang.k_266001') }}
      <a href="javaScript:void(0);" v-if="btn_invite" class="link" @click="toInviteSetting">
        {{ $t('lang.k_266002') }}
      </a>
    </h3>
    <div class="share-modal-content">
      <div class="link-section">
        <vh-form label-width="64px">
          <vh-form-item :label="$t('lang.k_266003')">
            <vh-input
              id="link-input"
              class="link-input"
              v-model="watchUrl"
              readonly
              :placeholder="$t('lang.k_266004')"
            ></vh-input>
            <vh-button
              type="text"
              class="copy-link"
              data-clipboard-target="#link-input"
              @click="copyLink('copy-link')"
            >
              {{ $t('lang.k_266005') }}
            </vh-button>
            <vh-button type="text" @click="openLink">{{ $t('lang.k_266006') }}</vh-button>
            <p class="tip-text">{{ $t('lang.k_266007') }}</p>
          </vh-form-item>
        </vh-form>
      </div>
      <div class="qr-code-section">
        <div class="qr-item" v-if="h5QrCodeSrc">
          <h4>{{ $t('lang.k_266008') }}</h4>
          <img :src="h5QrCodeSrc" :alt="$t('lang.k_266009')" class="qr-code-img" />
          <vh-button round type="primary" @click="downloadH5QrCode">
            {{ $t('lang.k_266010') }}
          </vh-button>
        </div>
        <div class="qr-item" v-if="miniProgramQrCodeSrc">
          <h4>{{ $t('lang.k_266011') }}</h4>
          <img :src="miniProgramQrCodeSrc" :alt="$t('lang.k_266012')" class="qr-code-img" />
          <vh-button round type="primary" @click="downloadMiniProgramQrCode">
            {{ $t('lang.k_266010') }}
          </vh-button>
        </div>
      </div>
    </div>
  </vh-dialog>
</template>

<script>
  import Env from '@/api/env';
  import { locationDownloadImage, isEmbed } from '@/utils/utils';
  import to from 'await-to-js';
  export default {
    name: 'ShareModal',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      userId: {},
      webinar: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        watchUrl: '', // 观看页链接
        h5QrCodeSrc: '', // H5观看二维码图片地址
        miniProgramQrCodeSrc: '' // 小程序观看二维码图片地址
      };
    },
    computed: {
      miniprogram_watch() {
        return !isEmbed() && this.$store.state.permission.miniprogram_watch == 1;
      },
      btn_invite() {
        return this.$store.state.permission.btn_invite == 1;
      }
    },
    methods: {
      init() {
        this.watchUrl = `${window.domainOfWatch()}/lives/watch/${this.webinar.webinar_id}`;
        this.h5QrCodeSrc = `${Env.staticLinkVo.aliQr}${window.domainOfWatch()}/lives/watch/${
          this.webinar.webinar_id
        }`;
        this.miniprogram_watch && this.getMiniprogramQrImage();
      },
      toInviteSetting() {
        const { webinar_id, webinar_type, webinar_state, vss_room_id, no_delay_webinar } =
          this.webinar;
        this.$router.push({
          path: '/live/invCard/' + webinar_id,
          query: {
            type: webinar_type,
            state: webinar_state,
            roomId: vss_room_id,
            isDelay: no_delay_webinar
          }
        });
      },
      handleClose() {
        this.$emit('update:visible', false);
      },
      copyLink(linkClass) {
        // 复制
        let clipboard = new this.$clipboard(`.${linkClass}`);
        clipboard.on('success', e => {
          this.$vhMessage({
            message: `${this.$t('lang.k_266013')}`,
            showClose: true,
            type: 'success',
            customClass: 'zdy-info-box'
          });
          e.clearSelection();
          clipboard.destroy();
        });
        clipboard.on('error', e => {
          this.$vhMessage({
            message: `${this.$t('lang.k_266014')}`,
            showClose: true,
            // duration: 0,
            type: 'success',
            customClass: 'zdy-info-box'
          });
          clipboard.destroy();
        });
      },
      openLink() {
        // 打开链接逻辑
        window.open(this.watchUrl, '_blank');
      },

      // 获取小程序二维码
      async getMiniprogramQrImage() {
        // https://developers.weixin.qq.com/miniprogram/dev/OpenApiDoc/qrcode-link/qr-code/getUnlimitedQRCode.html#%E8%B0%83%E7%94%A8%E6%96%B9%E5%BC%8F
        // 小程序的版本:release,trial,develop,默认release
        let env_version = this.$route.query?.env_version;
        if (!env_version && process.env.VUE_APP_ENV === 'test') {
          // 测试环境默认体验版
          env_version = 'trial';
        }
        const params = {
          biz_id: process.env.VUE_APP_BIZ_ID || 2,
          biz_application_id: process.env.VUE_APP_APP_ID,
          business_uid: this.userId,
          page_path: 'pages/index/index',
          page_args: `s=1&wId=${this.webinar.webinar_id}`, // 长度不超过32个字符
          env_version: ['trial', 'develop'].includes(env_version) ? env_version : 'release'
        };
        const [err, res] = await to(
          this.$fetch('getMiniprogramQrImage', params, {
            'Content-Type': 'application/json'
          })
        );
        if (err || !res || res.code != 200 || !res.data) {
          this.$vhMessage.error(err?.msg || res?.msg || this.$t('lang.k_266015'));
          return;
        }
        this.miniProgramQrCodeSrc = res.data.qr_image;
      },
      // 下载小程序二维码
      downloadMiniProgramQrCode() {
        locationDownloadImage(this.miniProgramQrCodeSrc, {
          name: `${this.webinar.subject || 'code'}` + this.$t('lang.k_266016') + `.png` // 设置图片名称
        });
      },
      downloadH5QrCode() {
        locationDownloadImage(this.h5QrCodeSrc, {
          name: `${this.webinar.subject || 'code'}` + this.$t('lang.k_266017') + `.png` // 设置图片名称
        });
      }
    },
    created() {
      this.init();
    }
  };
</script>

<style scoped lang="less">
  .dialog-title {
    font-weight: 600;
    font-size: 18px;
    a {
      margin-left: 10px;
      font-size: 14px;
    }
  }
  .link-section {
    margin-bottom: 20px;
    .link-input {
      width: calc(100% - 96px);
      margin-right: 10px;
    }
  }
  .tip-text {
    font-size: 12px;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
  }
  .qr-code-section {
    display: flex;
    justify-content: space-around;
    padding-bottom: 10px;
  }
  .qr-item {
    text-align: center;
  }
  .qr-code-img {
    width: 140px;
    height: 140px;
    margin: 10px 0;
    display: block;
  }
</style>
